// src/Components/Pages/PrivacyPolicy.js
import React from "react";
import "./Privacy&Policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-container">
      <h1>Privacy Policy</h1>

      <h2>1. Who We Are</h2>
      <p>
        We are CUTTECH SOLUTIONS, proudly built in India by SIMPLE MECHANICAL SOLUTIONS, part of the dynamic and diversified SAGAR GROUP OF INDUSTRIES. This privacy policy explains how we collect, use, protect, and share your personal data when you interact with us—online or offline.
      </p>

      <h2>2. What Data We Collect</h2>
      <p>We collect personal information that you willingly share with us while:</p>
      <ul>
        <li>Browsing our website or mobile platforms</li>
        <li>Filling out enquiry forms or responding to surveys</li>
        <li>Communicating with us via email, phone, or chat</li>
        <li>Making a purchase or requesting a quotation</li>
      </ul>
      <p>We may collect:</p>
      <ul>
        <li><strong>Basic Info:</strong> Name, email, phone, address</li>
        <li><strong>Login/Account Details:</strong> Username, preferences</li>
        <li><strong>Device & Web Info:</strong> IP address, browser type, device type</li>
        <li><strong>Order Data:</strong> Purchase history and payment info</li>
      </ul>

      <h2>3. Why We Use Your Data</h2>
      <ul>
        <li>Processing orders and inquiries</li>
        <li>Providing technical or customer support</li>
        <li>Sending important service updates or promotional materials (only if you’ve opted in)</li>
        <li>Improving user experience and functionality of our websites</li>
        <li>Complying with legal and regulatory obligations</li>
        <li>Protecting our platforms and users from misuse or fraud</li>
      </ul>

      <h2>4. Our Legal Basis</h2>
      <ul>
        <li>You give us explicit permission</li>
        <li>It’s necessary to fulfill a contract or transaction</li>
        <li>We are legally required to do so</li>
        <li>It supports our legitimate business interests and does not override your privacy rights</li>
      </ul>

      <h2>5. Cookies & Tracking</h2>
      <p>
        We use cookies to personalize your browsing experience and understand user behavior. You have full control to accept or reject cookies through your browser settings. We also offer a cookie preference center where you can change your consent at any time.
      </p>

      <h2>6. Sharing Your Data</h2>
      <p>We do not sell your personal data. We may share your data with:</p>
      <ul>
        <li>Trusted service providers (e.g., IT, logistics, CRM) under strict agreements</li>
        <li>Other group entities of SAGAR’S GROUP OF INDUSTRIES if needed for operations</li>
        <li>Government authorities, when legally obligated</li>
      </ul>
      <p>For international transfers, we ensure your data is protected with standard legal safeguards.</p>

      <h2>7. How Long We Keep Your Data</h2>
      <p>
        We keep your data only for as long as it is needed to fulfill the original purpose or as required by law. After this, it will be securely deleted or anonymized.
      </p>

      <h2>8. Your Rights</h2>
      <ul>
        <li>Request access to the data we hold about you</li>
        <li>Ask for corrections or deletion</li>
        <li>Limit how we use your data</li>
        <li>Object to data processing in specific cases</li>
        <li>Request a portable copy of your data</li>
        <li>Withdraw your consent anytime</li>
        <li>Lodge a complaint with your local Data Protection Authority</li>
      </ul>

      <h2>10. For India Residents</h2>
      <p>
        CUTTECH SOLUTIONS is committed to full compliance with the Digital Personal Data Protection Act, 2023 (DPDPA).
      </p>
      <ul>
        <li>You are 18 years or older</li>
        <li>You have given us clear and informed consent</li>
      </ul>
      <p>
        We limit the use of your data strictly to the purpose you agreed upon. Once the DPDPA is fully enforced, we will update this policy accordingly.
      </p>

      <h2>11. How to Contact Us</h2>
      <p>
        For any concerns, requests, or complaints regarding your data, feel free to contact our Data Protection Officer (DPO):
      </p>
      <address>
        <strong>Postal Address:</strong><br />
        CUTTECH SOLUTIONS<br />
        SIMPLE MECHANICAL SOLUTIONS Unit<br />
        Sunkadakatte Industrial Area,<br />
        Bangalore – 560091, India
      </address>
      <p>(For China-based users, responses will be made within 15 working days as per PIPL.)</p>

      <h2>12. Changes to This Policy</h2>
      <p>
        We may update this policy as needed. Whenever we do, the revised version will be published on our official website. Please review this page periodically.
      </p>
    </div>
  );
};

export default PrivacyPolicy;
